const PATH = "/api/v1";

const ENDPOINTS = {
  WEBAPP_BLOGS: "/blog/posts/",
  WEBAPP_BLOG: "/blog/posts/",
  WEBAPP_BLOGS_DESTINATION: "/blog/destination/",
};

export type BlogEndpoints = keyof typeof ENDPOINTS;
export const BlogCollection = { PATH, ENDPOINTS };
